// Картинки-образцы стиля курса. На бэке — JSON-колонка `style_references`
// (до трёх URL), и это ПОЛНАЯ замена списка, как у `mascots`: любой PUT несёт
// весь список целиком, а пустой массив снимает образцы. Порядок значим —
// первая картинка для модели главнее.
export const MAX_STYLE_REFERENCES = 3

export const canAddStyleReference = (current: string[]): boolean =>
  current.length < MAX_STYLE_REFERENCES

export const appendStyleReference = (current: string[], url: string): string[] =>
  canAddStyleReference(current) ? [...current, url] : current

export const removeStyleReferenceAt = (current: string[], index: number): string[] => {
  if (index < 0 || index >= current.length) return current
  const next = [...current]
  next.splice(index, 1)
  return next
}
